import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, mobileAndTabletCSS, tabletCSS } from '@measures/responsive'
import useIsInUltraModuleBundling from '@hooks/useIsInUltraModuleBundling'
import TeaserToiCommercialWrapper from '@components/TeaserToiCommercial/Wrapper'

interface MainItemWrapperProps {
  children: ReactNode
  accentColor?: string
  hasSportsPartner?: boolean
}

const StyledMainItemWrapper = styled.div<
  Pick<MainItemWrapperProps, 'accentColor' | 'hasSportsPartner'>
>`
  ${({
    theme: {
      colors: { staticRed500 },
      spacing: { spacing8, spacing16 },
      measures: {
        stretchWidthOnMobile,
        outerPadding: { desktop: desktopPadding },
      },
    },
    accentColor,
    hasSportsPartner,
  }) => css`
    position: relative;
    grid-column: 1 / -1;
    ${desktopCSS(css`
      border-left: ${desktopPadding} solid ${accentColor ?? staticRed500};
      margin-left: -${desktopPadding};
    `)};
    ${tabletCSS(css`
      margin-left: -${spacing16};
      ${TeaserToiCommercialWrapper} {
        padding-right: ${spacing8};
        padding-left: ${spacing16};
      }
    `)}

    ${mobileAndTabletCSS(css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;

        width: 8px;
        height: calc(100% - ${spacing8});
        ${hasSportsPartner &&
        css`
          height: 100%;
        `}
        ${tabletCSS(css`
          height: 100%;
        `)}

        ${stretchWidthOnMobile()};

        background: ${accentColor ?? staticRed500};
      }
    `)};
  `}
`

const MainItemWrapper: FunctionComponent<MainItemWrapperProps> = ({
  children,
  accentColor,
  hasSportsPartner,
}) => {
  const hasBundling = useIsInUltraModuleBundling()
  if (!hasBundling) {
    return children
  }

  return (
    <StyledMainItemWrapper
      accentColor={accentColor}
      hasSportsPartner={hasSportsPartner}
    >
      {children}
    </StyledMainItemWrapper>
  )
}

export default MainItemWrapper
